import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { IconButtonProps, Skeleton, Tooltip } from '@breathelife/mui';

import { IconButton as StyledIconButton, IconButtonStyleProps } from './Styles';

const SKELETON_DIAMETER = 36;

type Props = {
  icon: ReactElement;
  title?: string;
  showSkeleton?: boolean;
} & IconButtonStyleProps &
  Omit<IconButtonProps, 'size'>;

export function IconButton(props: Props): ReactElement {
  const { t } = useTranslation();
  const { icon, title, showSkeleton, ...rest } = props;

  if (showSkeleton) return <Skeleton variant='circular' width={SKELETON_DIAMETER} height={SKELETON_DIAMETER} />;

  if (title)
    return (
      <Tooltip placement='top' title={`${props.disabled ? `${t('cta.disabled')}: ` : ''} ${title}`} disableInteractive>
        <div>
          <StyledIconButton {...rest}>{icon}</StyledIconButton>
        </div>
      </Tooltip>
    );

  return <StyledIconButton {...rest}>{icon}</StyledIconButton>;
}
